import React, {Component} from "react";
import {Button, Glyphicon, PageHeader} from "react-bootstrap";
import "./SentEmails.css";
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import * as userLib from "../libs/user-lib";
import {columnDefsUsers} from "../libs/columnDefUsers";
import {subId} from "../libs/globalDefUsers";
import {saveAs} from "file-saver";
const API = require("../libs/awsApiWrappers");

export const nl = '\r\n';

export default class SentEmailsTemp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            users: [],
            selectedEmails: [],
            isEditor: userLib.isCustomEditor(this.props.currentUser, 'send_emails'),
            isViewer: userLib.isCustomViewer(this.props.currentUser, 'send_emails'),

            fileContent: [],
            columnDefs: columnDefsUsers,

            defaultColDef: {
                sortable: true,
                filter: true,
                lockPinned: true,
                resizable: true
            },
            style: {
                width: '100%',
                height: '644px'
                // height: '364px'
                // height: '2884px'
            },
            rowSelection: "single",
            paginationPageSize: 100,
            paginationNumberFormatter: function (params) {
                return params.value.toLocaleString();
            }
        };

        this.state.columnDefs[0].checkboxSelection = true;
        const self = this;
        this.state.columnDefs[0].cellRenderer = API.getCustomCellRenderer("users", self,
            () => { self.props.setUserToDuplicate(null) }, subId);

    }

    addOutputLine(line) {
        this.addOutput(line + nl);
    }

    addOutput(line) {
        this.state.fileContent.push(line);
        this.setState({fileContent: this.state.fileContent});
    }

    clearOutput() {
        this.setState({fileContent: ""});
    }

    onGridReady = params => {
        this.gridApi = params.api;
        // this.gridColumnApi = params.columnApi;

        const updateData = data => {
            this.props.setRowDataEmails(data);
            params.api.paginationGoToPage(0);
        };

        updateData(this.props.rowDataEmails);
        const value = this.props.searchBoxValue;
        document.getElementById('filter-text-box').value = value;
        // params.api.setGridOption("quickFilterText", value);

        const valuePageSize = this.props.pageSize;
        document.getElementById("page-size").value = valuePageSize;
        this.gridApi.setGridOption("paginationPageSize", Number(valuePageSize));
    };


    onPageSizeChanged() {
        // const pxPerRow = 28;
        const value = document.getElementById("page-size").value;
        this.props.setPageSize(value);
        this.gridApi.setGridOption("paginationPageSize", Number(value));

        // const newHeight = ((Number(value) + 3) * pxPerRow).toString() + "px";
        // this.setHeight(newHeight);
    }

    onSelectionChanged() {
        this.setState({selectedEmails: this.gridApi.getSelectedRows()});
    }

    componentDidUpdate() {
        if (this.gridApi) {
            this.gridApi.refreshCells();
        }
    }

    async componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        this.setState({isEditor: userLib.isCustomEditor(this.props.currentUser, 'send_emails')});
        this.setState({isViewer: userLib.isCustomViewer(this.props.currentUser, 'send_emails')});

        if (this.props.rowDataEmails.length === 0) {
            try {
                const emails = await this.emails("");
                let tempResult = emails;
                while (tempResult.LastEvaluatedKey) {
                    tempResult = await this.emails(tempResult.LastEvaluatedKey);
                    emails.Items = emails.Items.concat(tempResult.Items);
                }

                let email;
                let counter = 0;
                const split = 49;
                for (email of emails.Items) {
                    this.addOutput(email.userId + ";");
                    counter++;
                    if (counter >= split) {
                        counter = 0;
                        this.addOutputLine("");
                        this.addOutputLine("");
                        this.addOutputLine("");
                    }
                }
                this.saveFile("All CamAPS FX CL users.txt");
                alert("Email addresses of CamAPS FX COMMERCIAL CLOSED-LOOP users have been downloaded and split into " +
                    "blocks of 50. These blocks can be pasted into BCC field when " +
                    "sending bulk emails to CamAPS FX commercial users.");
            } catch (e) {
               API.handleApiErrorWithAlert(e, this);
            }
        } else {
            this.setState({
                isEditor: userLib.isEditor(this.props.groups) ||
                    userLib.isAdminEditor(this.props.groups)
            });
        }

        this.props.setUpdateTimeOutListener();
        this.setState({isLoading: false});

        this.props.history.push("/pumps");
    }

    emails(lastEvaluatedKey) {
        let myInit = {
            queryStringParameters: {}
        };
        if (lastEvaluatedKey && ("" !== lastEvaluatedKey)) {
            myInit.queryStringParameters.LastEvaluatedKeyPumpSN = lastEvaluatedKey.pumpSN;
        }
        return API.get("pumps", "/emailstemp", myInit);
    }

    onFilterTextBoxChanged() {
        if (this.gridApi) {
            const value = document.getElementById('filter-text-box').value;
            this.props.setSearchBox(value);
            this.gridApi.setGridOption("quickFilterText", value);
        }
    }

    saveFile(outFileName) {
        const blob = new Blob(this.state.fileContent, {type: "text/plain;charset=utf-8"});
        saveAs(blob, outFileName);
    }

    onAddUser() {
        this.props.setUserToDuplicate(null);
        this.props.history.push('/users/new');
    }

    onDuplicateUser() {
        this.props.setUserToDuplicate(this.state.selectedEmails);
        this.props.history.push('/users/new');
    }

    onBtExport() {
        const params = {
            skipHeader: false,
            skipFooters: false,
            skipGroups: false,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: true,
            onlySelected: false,
            suppressQuotes: true,
            fileName: "CamAPS users",
            columnSeparator: ',',
            customHeader: "CamAPS users\n"
        };
        this.gridApi.exportDataAsCsv(params);
    }

    renderEmailsList() {
        return (
            <div style={{width: "100%", height: "100%"}}>
                <div className="pump-container">
                    <div className="page-container">
                        {this.state.isEditor ?
                            <Button className="button-add pull-left" bsStyle="primary" bsSize="small"
                                    onClick={this.onAddUser.bind(this)}>
                                Add user
                            </Button> : null
                        }
                        {this.state.isEditor ?
                            <Button className="button-duplicate pull-left" bsStyle="primary" bsSize="small"
                                    margin-left={20}
                                    disabled={this.state.selectedEmails.length === 0}
                                    hidden={this.state.isEditor}
                                    onClick={this.onDuplicateUser.bind(this)}>
                                Duplicate user
                            </Button> : null
                        }
                        <Button className="pull-right" bsStyle="info" bsSize="small"
                                onClick={this.onBtExport.bind(this)}>
                            <Glyphicon glyph="file"/> Export to Excel
                        </Button>
                    </div>
                    <div className="page-container">
                        <div className="page-size-header pull-left">
                            Page size:&nbsp;
                            <select onChange={this.onPageSizeChanged.bind(this)} id="page-size" defaultValue={'100'}>
                                {/*<select id="page-size" defaultValue={'100'}>*/}
                                <option value="10">10</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                                <option value="1000">1000</option>
                            </select>
                        </div>
                        <input className="pull-right" type="text" id="filter-text-box" placeholder="Search..."
                               onInput={this.onFilterTextBoxChanged.bind(this)}/>
                    </div>
                    <div style={{minHeight: "400px", height: "calc(100% - 30px)"}}>
                        <div
                            id="usersGrid"
                            style={this.state.style}
                            className="ag-theme-balham"
                        >
                            <AgGridReact
                                columnDefs={this.state.columnDefs}
                                defaultColDef={this.state.defaultColDef}
                                rowSelection={this.state.rowSelection}
                                onGridReady={this.onGridReady}
                                enableCellTextSelection={true}
                                onSelectionChanged={this.onSelectionChanged.bind(this)}
                                pagination={true}
                                paginationPageSize={this.state.paginationPageSize}
                                paginationNumberFormatter={this.state.paginationNumberFormatter}
                                rowData={this.props.rowDataEmails}
                                headerHeight={58}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderLander() {
        return (
            <div className="lander">
                <h1>Access not allowed. Not authenticated</h1>
            </div>
        );
    }

    getHeader() {
        if (this.state.isLoading) {
            return ('Loading ...');
        } else if (!this.props.rowData || (this.props.rowData.length === 0)) {
            return ('CamAPS emails to customers');
        } else {
            return ('Emails')
        }
    }

    renderEmails() {
        return (
            <div className="pumps">
                {/*<div className="left-header pull-left">*/}
                <PageHeader>
                    <div className="header">
                        <div className="left-header pull-left">
                            {this.getHeader()}
                        </div>
                        <div className="clearfix"/>
                    </div>
                </PageHeader>
                {!this.state.isLoading && this.renderEmailsList()}
            </div>
        );
    }

    render() {
        return (
            <div className="Home">
                {this.props.isAuthenticated ? this.renderEmails() : this.renderLander()}
            </div>
        );
    }
}
